import Header from "../Header";

const GeneralHeader = () => {
  const linkList = [
    {
      href: 'https://www.ghmt.de/index.php?id=240',
      title: 'Datenschutz'
    },
    {
      href: 'https://ghmt.de/index.php?id=187',
      title: 'Impressum'
    },
    {
      href: 'https://ghmt.de',
      title: 'Homepage'
    }
  ];

  return (
    <Header
      linkList={linkList}
    />
  )
}

export default GeneralHeader;